/* eslint-disable no-unused-vars */
"use client";
import React, { useEffect, useRef, useState, useCallback } from "react";
import { Images, Icons } from "@assets/assets";
import Image, { StaticImageData } from "next/image";
import IndustryBenefitCard from "./IndsutryBenifitCard";
import IndustryBenifitsHeaderSection from "./IndustryHeaderSection";
import IndustryBenifitsScroll from "./IndustryBenifitsScroll";
// --- Types ---

export type BenefitItem = {
  icon: StaticImageData | string | undefined;
  title: string[] | string;
  description: string;
};

export type HeaderConfig = {
  title: React.ReactNode;
  subtitle: string;
  description: string;
  buttonText?: string;
  mode?: "dark" | "light" | string;
  layoutVariant?: 1 | 2;
};

export type IndustryBenifitsProps = {
  id?: string;
  header: HeaderConfig;
  benefits: BenefitItem[];
  ctaButton: React.ReactNode;
};

export default function IndustryBenifits({
  id = "industry-benifits-food-delivery",
  header,
  benefits,
  ctaButton,
}: IndustryBenifitsProps) {
  return (
    <section
      id={id}
      className="w-full max-w-[100vw] relative overflow-hidden bg-[#000000]"
    >
      <IndustryBenifitsHeaderSection header={header} ctaButton={ctaButton} />
      <IndustryBenifitsScroll benefits={benefits} />
    </section>
  );
}
